import { cbSemanticCssVars, WoltLogo } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

const Root = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background-color: ${cbSemanticCssVars.borderPrimary};
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledWoltLogo = styled(WoltLogo).attrs({ height: 14 })`
  fill: ${cbSemanticCssVars.textTertiary};
`;

const EmptyThumbnail = ({ className }: { className?: string }) => {
  return (
    <Root className={className}>
      <StyledWoltLogo />
    </Root>
  );
};

export default React.memo(EmptyThumbnail);
